import type { ReactNode } from "react";
import "./filter-bar.css";
/** Visible labels above every control; input examples belong in placeholders. */
export function FilterBar({
  children,
  label = "검색 및 필터",
}: {
  children: ReactNode;
  label?: string;
}) {
  return (
    <div className="filter-bar" role="group" aria-label={label}>
      {children}
    </div>
  );
}
